import React, { useState, useEffect } from 'react';
import Header from "common/js/header/header";
import 'common/css/master.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MapStudentLocation from './mapsStudentLocation';
import RangesTable from './rangesTable';
import RangeSlider from './rangeSlider';

const apiKey = "AIzaSyC_G16AeOUmhNAP9FuTvreRhFTs31bL4mQ";


const StudentLocation = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [studentCount, setStudentCount] = useState(0);
    const [remainingCount, setRemainingCount] = useState(0);

    const [schoolCoordinates, setSchoolCoordinates] = useState({
        lat: 28.6177426,
        lng: 77.3848201,
    });

    const [lstTransportStudents, setLstTransportStudents] = useState([
        { studentId: 1, student: "John Doe", address: "123 Main St, New Delhi, India", cls: "5th", section: "A" },
        { studentId: 2, student: "Jane Smith", address: "456 Elm St, New Delhi, India", cls: "6th", section: "B" },
        { studentId: 3, student: "Alice Johnson", address: "789 Oak St, New Delhi, India", cls: "7th", section: "C" },
        { studentId: 4, student: "Bob Brown", address: "101 Pine St, New Delhi, India", cls: "8th", section: "A" },
        { studentId: 5, student: "Charlie Davis", address: "202 Maple St, New Delhi, India", cls: "9th", section: "B" },
        { studentId: 6, student: "David Wilson", address: "303 Cedar St, New Delhi, India", cls: "5th", section: "A" },
        { studentId: 7, student: "Emma Thomas", address: "404 Birch St, New Delhi, India", cls: "6th", section: "B" },
        { studentId: 8, student: "Olivia White", address: "505 Walnut St, New Delhi, India", cls: "7th", section: "C" },
        { studentId: 9, student: "Liam Harris", address: "606 Chestnut St, New Delhi, India", cls: "8th", section: "A" },
        { studentId: 10, student: "Sophia Martin", address: "707 Spruce St, New Delhi, India", cls: "9th", section: "B" },
        { studentId: 11, student: "Mason Clark", address: "808 Redwood St, New Delhi, India", cls: "5th", section: "A" },
        { studentId: 12, student: "Isabella Lewis", address: "909 Cypress St, New Delhi, India", cls: "6th", section: "B" },
        { studentId: 13, student: "Ethan Walker", address: "1010 Palm St, New Delhi, India", cls: "7th", section: "C" },
        { studentId: 14, student: "Ava Hall", address: "1111 Willow St, New Delhi, India", cls: "8th", section: "A" },
        { studentId: 15, student: "James Allen", address: "1212 Aspen St, New Delhi, India", cls: "9th", section: "B" },
        { studentId: 16, student: "Aastha gupa", address: "Fortis hospital, Sector 62, Noida, India", cls: "9th", section: "B" },
        { studentId: 17, student: "Student 17", address: "Near Shiv Mandir, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 18, student: "Student 18", address: "Near HDFC Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 19, student: "Student 19", address: "Near Axis Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 20, student: "Student 20", address: "Near ICICI Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 21, student: "Student 21", address: "Near Kotak Mahindra Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 22, student: "Student 22", address: "Near Yes Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 23, student: "Student 23", address: "Near Punjab National Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 24, student: "Student 24", address: "Near Canara Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 25, student: "Student 25", address: "Near Union Bank of India ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 26, student: "Student 26", address: "Near Bank of Baroda ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 27, student: "Student 27", address: "Near IndusInd Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 28, student: "Student 28", address: "Near IDBI Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 29, student: "Student 29", address: "Near Central Bank of India ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 30, student: "Student 30", address: "Near State Bank of India ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 31, student: "Student 31", address: "Near Allahabad Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 32, student: "Student 32", address: "Near Corporation Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 33, student: "Student 33", address: "Near Oriental Bank of Commerce ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 34, student: "Student 34", address: "Near Syndicate Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 35, student: "Student 35", address: "Near Andhra Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 36, student: "Student 36", address: "Near Union Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 37, student: "Student 37", address: "Near Dena Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 38, student: "Student 38", address: "Near Vijaya Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 39, student: "Student 39", address: "Near Bank of Maharashtra ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 40, student: "Student 40", address: "Near Indian Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 41, student: "Student 41", address: "Near Indian Overseas Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 42, student: "Student 42", address: "Near UCO Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 43, student: "Student 43", address: "Near Punjab & Sind Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 44, student: "Student 44", address: "Near Bharatiya Mahila Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 45, student: "Student 45", address: "Near IDFC Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 46, student: "Student 46", address: "Near Bandhan Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 47, student: "Student 47", address: "Near Catholic Syrian Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 48, student: "Student 48", address: "Near City Union Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 49, student: "Student 49", address: "Near DCB Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 50, student: "Student 50", address: "Near Dhanlaxmi Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 51, student: "Student 51", address: "Near Federal Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 52, student: "Student 52", address: "Near Jammu & Kashmir Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 53, student: "Student 53", address: "Near Karnataka Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 54, student: "Student 54", address: "Near Karur Vysya Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 55, student: "Student 55", address: "Near Lakshmi Vilas Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 56, student: "Student 56", address: "Near Nainital Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 57, student: "Student 57", address: "Near RBL Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 58, student: "Student 58", address: "Near South Indian Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 59, student: "Student 59", address: "Near Tamilnad Mercantile Bank ATM, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 60, student: "Student 60", address: "Near Yes Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 61, student: "Student 61", address: "Near IndusInd Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 62, student: "Student 62", address: "Near HDFC Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 63, student: "Student 63", address: "Near ICICI Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 64, student: "Student 64", address: "Near Axis Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 65, student: "Student 65", address: "Near Kotak Mahindra Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 66, student: "Student 66", address: "Near Punjab National Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 67, student: "Student 67", address: "Near Canara Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 68, student: "Student 68", address: "Near Union Bank of India, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 69, student: "Student 69", address: "Near Bank of Baroda, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 70, student: "Student 70", address: "Near IDBI Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 71, student: "Student 71", address: "Near Central Bank of India, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 72, student: "Student 72", address: "Near State Bank of India, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 73, student: "Student 73", address: "Near Allahabad Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 74, student: "Student 74", address: "Near Corporation Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 75, student: "Student 75", address: "Near Oriental Bank of Commerce, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 76, student: "Student 76", address: "Near Syndicate Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 77, student: "Student 77", address: "Near Andhra Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 78, student: "Student 78", address: "Near Dena Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 79, student: "Student 79", address: "Near Vijaya Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 80, student: "Student 80", address: "Near Bank of Maharashtra, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 81, student: "Student 81", address: "Near Indian Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 82, student: "Student 82", address: "Near Indian Overseas Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 83, student: "Student 83", address: "Near UCO Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 84, student: "Student 84", address: "Near Punjab & Sind Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 85, student: "Student 85", address: "Near Bharatiya Mahila Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 86, student: "Student 86", address: "Near IDFC Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 87, student: "Student 87", address: "Near Bandhan Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 88, student: "Student 88", address: "Near Catholic Syrian Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 89, student: "Student 89", address: "Near City Union Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 90, student: "Student 90", address: "Near DCB Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 91, student: "Student 91", address: "Near Dhanlaxmi Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 92, student: "Student 92", address: "Near Federal Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 93, student: "Student 93", address: "Near Jammu & Kashmir Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 94, student: "Student 94", address: "Near Karnataka Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 95, student: "Student 95", address: "Near Karur Vysya Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 96, student: "Student 96", address: "Near Lakshmi Vilas Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 97, student: "Student 97", address: "Near Nainital Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 98, student: "Student 98", address: "Near RBL Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 99, student: "Student 99", address: "Near South Indian Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "C" },
        { studentId: 100, student: "Student 100", address: "Near Tamilnad Mercantile Bank, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "A" },
        { studentId: 101, student: "Student 101", address: "Near a park, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "B" },
        { studentId: 102, student: "Student 102", address: "Near a school, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "A" },
        { studentId: 103, student: "Student 103", address: "Near a shopping mall, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "9th", section: "B" },
        { studentId: 104, student: "Student 104", address: "Near a restaurant, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "12th", section: "C" },
        { studentId: 105, student: "Student 105", address: "Near a bus stop, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "10th", section: "A" },
        { studentId: 106, student: "Student 106", address: "Near a train station, Sector 62, Noida, Uttar Pradesh 201309, India", cls: "11th", section: "B" },
        { studentId: 107, student: "Student 107", address: "Ghaziabad, Uttar Pradesh, India", cls: "9th", section: "C" },
        { studentId: 108, student: "Student 108", address: "Ghaziabad, Uttar Pradesh, India", cls: "12th", section: "A" },
        { studentId: 109, student: "Student 109", address: "Ghaziabad, Uttar Pradesh, India", cls: "10th", section: "B" },
        { studentId: 110, student: "Student 110", address: "Ghaziabad, Uttar Pradesh, India", cls: "11th", section: "A" },
        { studentId: 111, student: "Student 111", address: "Ghaziabad, Uttar Pradesh, India", cls: "9th", section: "B" },
        { studentId: 112, student: "Student 112", address: "Ghaziabad, Uttar Pradesh, India", cls: "12th", section: "C" },
        { studentId: 113, student: "Student 113", address: "Ghaziabad, Uttar Pradesh, India", cls: "10th", section: "A" },
        { studentId: 114, student: "Student 114", address: "Ghaziabad, Uttar Pradesh, India", cls: "11th", section: "B" },
        { studentId: 115, student: "Student 115", address: "Ghaziabad, Uttar Pradesh, India", cls: "9th", section: "C" },
        { studentId: 116, student: "Student 116", address: "Ghaziabad, Uttar Pradesh, India", cls: "12th", section: "A" }
    ]);

    const [lstRanges, setLstRanges] = useState([]);
    const [rangeId, setRangeId] = useState(0);
    const [studentsWithCoordinates, setStudentsWithCoordinates] = useState([]);
    const [flgSlider, setFlgSlider] = useState(false);



    useEffect(() => {
        fetchCoordinates(lstTransportStudents, setStudentsWithCoordinates);
    }, [lstTransportStudents]);

    useEffect(() => {
        updateStudentCounts([
            { rangeId: 1, km: 1, count: 0, fees: 1000 },
            { rangeId: 2, km: 3, count: 0, fees: 2000 },
            { rangeId: 3, km: 5, count: 0, fees: 3000 },
            { rangeId: 4, km: 10, count: 0, fees: 4000 },
            { rangeId: 5, km: 100, count: 0, fees: 40000 },
        ]);
    }, [studentsWithCoordinates, schoolCoordinates]);

    // Define helper function outside useEffect
    const fetchCoordinates = async (students, setStudentsWithCoordinates) => {
        const geocodedStudents = await Promise.all(
            students.map(async (student) => {
                const response = await fetch(
                    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                        student.address
                    )}&key=${apiKey}`
                );
                const data = await response.json();
                if (data.results && data.results[0]) {
                    const { lat, lng } = data.results[0].geometry.location;
                    return { ...student, coordinate: { lat, lng } };
                }
                return student;
            })
        );
        setStudentsWithCoordinates(geocodedStudents);
    };

    // Function to calculate the count of students in each range
    const updateStudentCounts = (newLstRanges) => {
        // console.log("updatedStudentCounts called, newLstRanges", newLstRanges);
        // console.log("studentsWithCoordinates", studentsWithCoordinates);
        if (newLstRanges.length > 0 && studentsWithCoordinates.length > 0) {
            // Sort ranges by km in ascending order
            const sortedRanges = [...newLstRanges].sort((a, b) => a.km - b.km);

            // Create a copy of students to track uncounted students
            let uncountedStudents = [...studentsWithCoordinates];

            // Update counts for each range
            const updatedRanges = sortedRanges.map((range) => {
                const studentsInRange = uncountedStudents.filter((student) => {
                    if (student.coordinate) {
                        const distance = calculateDistance(
                            schoolCoordinates.lat,
                            schoolCoordinates.lng,
                            student.coordinate.lat,
                            student.coordinate.lng
                        );
                        return distance <= range.km;
                    }
                    return false;
                });

                // Remove counted students from uncountedStudents
                uncountedStudents = uncountedStudents.filter(
                    (student) => !studentsInRange.includes(student)
                );

                return { ...range, count: studentsInRange.length };
            });

            // Update state
            setLstRanges(updatedRanges);
            setStudentCount(lstTransportStudents.length);
            setRemainingCount(uncountedStudents.length);
        } else {
            setLstRanges([]);
            setStudentCount(lstTransportStudents.length);
            setRemainingCount(lstTransportStudents.length);
        }
    };

    // Function to calculate the distance between two coordinates using the Haversine formula
    const calculateDistance = (lat1, lng1, lat2, lng2) => {
        const toRadians = (degree) => (degree * Math.PI) / 180;
        const earthRadius = 6371; // Radius of the Earth in kilometers

        const dLat = toRadians(lat2 - lat1);
        const dLng = toRadians(lng2 - lng1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadians(lat1)) *
            Math.cos(toRadians(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadius * c; // Distance in kilometers
    };

    const deleteRange = (rangeId) => {
        // Show a confirmation dialog before deleting
        const confirmDelete = window.confirm("Are you sure you want to delete this range?");
        if (confirmDelete) {
            // console.log("deleteRange called", rangeId);
            const updatedRanges = lstRanges.filter((range) => range.rangeId !== rangeId);
            updateStudentCounts(updatedRanges);
            setRangeId(null);
        }
    };

    const editRange = (rangeId) => {
        setRangeId(rangeId);
        setFlgSlider(true);
    }

    const addRange = () => {
        setRangeId(0);
        setFlgSlider(true);
    };

    const closeSlider = () => {
        setFlgSlider(false);
    };

    const saveRanges = (newRanges) => {
        // console.log("saveRanges called", newRanges);
    }

    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div style={{
                position: 'fixed',
                zIndex: 10000,
                width: 100,
                height: 100,
                marginLeft: -50,
                marginTop: -50,
                left: '50%',
                top: '50%',
                display: loader
            }}>
                <img
                    className="loderImg"
                    src={require("common/images/loader.gif")}
                    alt="Loader..." />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 "
                style={{
                    pointerEvents: loader === "none" ? "auto" : "none",
                    opacity: opacity,
                    marginTop: "5vh"
                }}>
                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                    {
                        studentsWithCoordinates.length > 0 ? (
                            <MapStudentLocation
                                studentsWithCoordinates={studentsWithCoordinates}
                                schoolCoordinates={schoolCoordinates}
                                lstRanges={lstRanges}
                                rangeId={rangeId}
                            />
                        ) : (
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                <h4>No Students Found</h4>
                            </div>
                        )
                    }
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 " style={{ marginTop: "5px" }}>
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                            <div className="col-lg-6 col-sm-8 pull-right"
                                style={{ border: "1px solid #ccc", borderRadius: "4px", padding: "0 5px" }} >
                                <label className=" col-sm-12 text-left  padding-remove "
                                    style={{ fontWeight: 400 }}>
                                    Total students: {studentCount}</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 " style={{ marginTop: "5px" }} >
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                            <div className="col-lg-6 col-sm-8  pull-right"
                                style={{ border: "1px solid #ccc", borderRadius: "4px", padding: "0 5px" }} >
                                <label className=" col-sm-12 text-left  padding-remove "
                                    style={{ fontWeight: 400 }}>
                                    Remaining students: {remainingCount}</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 " >
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 pull-right" >
                            <span
                                id="addFacility"
                                title="Add Facility"
                                className="addIcon glyphicon glyphicon-plus-sign"
                                onClick={() => addRange()}
                            ></span>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 " >
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 " >
                            <RangesTable
                                rangeId={rangeId}
                                setRangeId={setRangeId}
                                lstRanges={lstRanges}
                                editRange={editRange}
                                deleteRange={deleteRange}
                            />
                        </div>
                        <div className='col-sm-12   padding-remove' style={{ height: "50px", marginTop: "20px" }}>
                            <div className="col-sm-2 col-md-2  padding-remove pull-right">
                                <button type="button" className="btn btn-info " onClick={() => saveRanges()} >Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                flgSlider ?
                    <div className="slider1-50">
                        <RangeSlider
                            rangeId={rangeId}
                            lstRanges={lstRanges}
                            updateStudentCounts={updateStudentCounts}
                            closeSlider={closeSlider}
                        />
                    </div>
                    : null
            }
        </div >
    );
};

export default StudentLocation;